import { render, staticRenderFns } from "./modal-cv-6-languages.vue?vue&type=template&id=a2ac4aaa&lang=html&"
import script from "./modal-cv-6-languages.vue?vue&type=script&lang=js&"
export * from "./modal-cv-6-languages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports